import { Link } from "react-router-dom";
import Container from "../Container";
import Title from "../Title";
import classes from "./index.module.scss";
import btnClasses from "../../../components/commons/Button.module.scss";
import { v4 as uuid } from "uuid";
import { reasons } from "../data";
import Card from "./Card";
import { useDeferredValue } from "react";

export default function Reasons() {
  const deferredReasons = useDeferredValue(reasons);
  return (
    <section>
      <Container>
        <div className={classes.body}>
          <Title center={false} className={classes.title}>
            Reasons for joining our team
          </Title>
          <ul className={classes.list}>
            {deferredReasons.map(({ images, title, list }) => (
              <li key={uuid()} className={classes.list__item}>
                <Card images={images} title={title} list={list} />
              </li>
            ))}
          </ul>
          <Link
            data-content="Go to career"
            className={`${btnClasses.button} ${classes.button}`}
            to="/vacancies"
          >
            Go to career
          </Link>
        </div>
      </Container>
    </section>
  );
}
